<template>
  <div>

    <modal-associa-video ref="modalTopicoVideo"
                        :cursos="cursos"
                        :professores="professores"
                        :videos-selecionadas="videosSelecionados"
                        :tipoVideo="'interno'"
                        @videosAssociadas="buscarVideos" />

    <modal-editar-massa ref="modalEditarMassa"
                        :professores="professores"
                        :cursos="cursos"
                        :modulos="modulos"
                        :licoes="licoes"
                        :videos-selecionadas="videosSelecionados"
                        @videosEditados="buscarVideos" />

    <modal-edicao-video ref="modalEdicaoVideo"
                        :videoEditar="videoEditar"
                        :cursos="cursos"
                        :modulos="modulos"
                        :licoes="licoes"
                        :professores="professores"
                        @videoEditado="buscarVideos" />

     <modal-cadastro-video ref="modalCadastroVideo"
                            :professores="professores"
                            @videoSalvo="buscarVideos" />

      <modal-upload-video ref="modalUploadVideo"
                            :professores="professores"
                            @videoSalvo="buscarVideos" />

    <div class="mb-2">
      <a class="btn btn-primary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Adicionar novo Vídeo <i class="fas fa-caret-down ml-1"></i>
      </a>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
        <a class="dropdown-item" href="javascript:void(0)" @click="changeRouter('vimeo')" v-if="perfil.isAdminJaleko || perfil.isEditor">Importar do Vímeo</a>
        <div class="dropdown-divider" v-if="perfil.isAdminJaleko || perfil.isEditor"></div>
        <a class="dropdown-item" href="javascript:void(0)" @click="modalCadastroVideo()">Cadastrar do Youtube</a>&#32;
        <div class="dropdown-divider" v-if="false"></div>
        <a class="dropdown-item" href="#" v-if="false">Importar do Youtube</a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#" @click="modalUploadVideo()">Upload de novo video</a>
      </div>
    </div>

    <div class="tab-pane fade show active" id="pills-videos" role="tabpanel" aria-labelledby="pills-videos-tab">
      <div>
        <b-link v-b-toggle="'collapse-filter-videos'" class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-filter"></i> Filtrar lista</b-link>&#32;
        <div class="dropdown btn-acoes mb-2 mb-md-0 d-inline-block">
          <a class="btn btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Ações
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item" href="javascript:void(0)" @click="modalAssociarVideo()">Associar à lição</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="javascript:void(0)" @click="modalEditarMassa()">Editar em Massa</a>
          </div>
        </div>
      </div>
    </div>

    <b-collapse id="collapse-filter-videos" class="filtros mt-3">
      <b-card>
        <form v-on:submit.prevent="buscarVideos">
          <div class="row align-items-center">
            <div class="col-12 col-md-11">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Nome do Vídeo</label>
                    <input type="text" class="form-control" placeholder="Nome do video" v-model="filtro.video" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Tipo</label>
                    <select class="form-control" v-model="filtro.tipo">
                      <option v-if="tipos.length == 0" value="">Carregando...</option>
                      <option v-if="tipos.length > 0" value="">Selecione</option>
                      <option v-for="tipo in tipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Curso</label>
                    <select class="form-control" v-model="filtro.cursoId">
                      <option v-if="cursos.length == 0" value="">Carregando...</option>
                      <option v-if="cursos.length > 0" value="">Selecione</option>
                      <option v-for="curso in cursos" :key="curso.id" :value="curso.id">{{ curso.curso }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Modulo</label>
                    <select class="form-control" v-model="filtro.moduloId">
                      <option v-if="modulos.length == 0" value="">Carregando...</option>
                      <option v-if="modulos.length > 0" value="">Selecione</option>
                      <option v-for="modulo in modulos" :key="modulo.id" :value="modulo.id">{{ modulo.modulo }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Lição</label>
                    <select class="form-control" v-model="filtro.licaoId">
                      <option v-if="licoes.length == 0" value="">Carregando...</option>
                      <option v-if="licoes.length > 0" value="">Selecione</option>
                      <option v-for="licao in licoes" :key="licao.id" :value="licao.id">{{ licao.licao }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Coordenador</label>
                    <select class="form-control" v-model="filtro.coordenador">
                      <option v-if="professores.length == 0" value="">Carregando...</option>
                      <option v-if="professores.length > 0" value="">Selecione</option>
                      <option v-for="coordenador in professores" :key="coordenador.id" :value="coordenador.id">{{ coordenador.professor }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Professor</label>
                    <select class="form-control" v-model="filtro.professor">
                      <option v-if="professores.length == 0" value="">Carregando...</option>
                      <option v-if="professores.length > 0" value="">Selecione</option>
                      <option v-for="professor in professores" :key="professor.id" :value="professor.id">{{ professor.professor }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-12 col-md-5">
                  <div class="form-group">
                    <label><input type="checkbox" v-model="filtro.createdDate" /> Filtrar por data de criação</label>
                    <date-range-picker
                      v-if="filtro.createdDate"
                      ref="picker"
                      :auto-apply="true"
                      opens="center"
                      v-model="filtro.createdDateRange"
                      :locale-data="dateRangeLocale"
                      :ranges="filtrosDateRangePredefinidos">
                    </date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-1">
              <button type="submit" class="btn-primary btn-filtros-busca"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </form>
      </b-card>
    </b-collapse>

    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-usuarios mt-2 position-relative" v-if="videos.length">
      <table class="table" ref="resultadoTabelaVideos">
        <thead>
          <tr>
            <th><input type="checkbox" v-model="selectAll" value="true"/></th>
            <th>#</th>
            <th>Nome do Vídeo (Tópico da Lição)</th>
            <th>Curso / Módulo / Lição</th>
            <th>Origem</th>
            <th>Link</th>
            <th>Coordenador</th>
            <th>Professor</th>
            <th>Data de Cadastro</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="video in videos" v-bind:key="'video'+video.id">
            <td><input type="checkbox" @click="alteraSelecionada(video)" v-model="videosSelecionados" :value="video"/></td>
            <td>{{ video.id }}</td>
            <td>{{ video.video }}</td>
            <td>
              {{ video.curso && video.curso.curso || ' - ' }}<br>
              {{ video.modulo && video.modulo.modulo || ' - ' }}<br>
              {{ video.licao && video.licao.licao || ' - ' }}
            </td>
            <td>{{ video.tipo && video.tipo.descricao || ' - '  }}</td>
            <td><a target="_blank" :href="video.link && video.link">{{ video.link && video.link || 'Sem link'  }}</a></td>
            <td>{{ video.coordenador && video.coordenador.professor || ' - ' }}</td>
            <td>{{ video.professor && video.professor.professor || ' - ' }}</td>
            <td>{{ video.created_at | formatDatetime }}</td>
            <td>
              <div class="d-flex align-items-center">
                <a href="javascript:void(0)" v-b-tooltip.hover title="Editar" @click="modalEdicaoVideo(video)"  v-if="video.editavel"><i class="fas fa-edit"></i></a>
                <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="deletarVideo(video)" v-if="video.ementas.length === 0"><i class="fas fa-trash-alt"></i></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up"></i>ir para o topo</a>
        </div>
      </transition>

    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import ModalCadastroVideo from '@/modules/Conteudo/components/ModalCadastroVideo'
import ModalEdicaoVideo from '@/modules/Conteudo/components/ModalEdicaoVideo'
import ModalAssociaVideo from '@/modules/Conteudo/components/ModalAssociaVideo'
import ModalEditarMassa from '@/modules/Conteudo/components/ModalEditarMassa'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import InfiniteLoading from 'vue-infinite-loading'
import DateUtils from '@/core/util/date-utils'
import ProfessorAPI from '@/api/professor-api'
import VideoAPI from '@/api/video-api'
import CursoAPI from '@/api/curso-api'
import ModuloAPI from '@/api/modulo-api'
import LicaoAPI from '@/api/licao-api'
import moment from 'moment'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'
import EmpresaUtils from '@/core/util/empresa-utils'
import ModalUploadVideo from '@/modules/Conteudo/components/ModalUploadVideo'

export default {
  name: 'ListaVideos',
  props: {
    perfil: Object
  },
  components: {
    InfiniteLoading,
    DateRangePicker,
    ModalAssociaVideo,
    ModalEditarMassa,
    ModalEdicaoVideo,
    ModalCadastroVideo,
    ModalUploadVideo
  },
  data () {
    return {
      pagina: 1,
      quantidade: 0,
      videos: [],
      infiniteId: new Date(),
      scrolled: false,
      licoes: [],
      modulos: [],
      cursos: [],
      professores: [],
      tipos: [],
      videosSelecionados: [],
      ultimoSelecionado: '',
      shiftPressed: false,
      selectAll: false,
      filtro: {
        id: '',
        video: '',
        cursoId: '',
        moduloId: '',
        licaoId: '',
        tipo: '',
        coordenador: '',
        professor: '',
        createdDateRange: {
          startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
          endDate: DateUtils.formatDate(new Date())
        }
      },
      filtrosDateRangePredefinidos: {
        'Esta semana': [moment().startOf('week'), moment().endOf('week')],
        'Última semana': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
        'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Este ano': [moment().startOf('year'), moment().endOf('year')]
      },
      dateRangeLocale: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      },
      videoEditar: {}
    }
  },

  mounted () {
    ProfessorAPI.listar().then(data => {
      this.professores = data
    })
    CursoAPI.listar(null, this.filtroCursos).then(data => {
      this.cursos = data
    })
    ModuloAPI.listar().then(data => {
      this.modulos = data
    })
    LicaoAPI.listar().then(data => {
      this.licoes = data
    })
    VideoAPI.listarTipos().then(data => {
      this.tipos = data
    })
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('keyup', this.handleKeyUp)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('keyup', this.handleKeyUp)
  },

  watch: {
    selectAll: function (value) {
      if (value) {
        this.videosSelecionados = this.videos
      } else {
        this.videosSelecionados = []
      }
    }
  },

  computed: {
    shift () {
      return this.shiftPressed
    },

    filtroCursos () {
      if (!this.perfil.isAdminJaleko) {
        return {
          empresa_id: EmpresaUtils.getEmpresa().id
        }
      } else {
        return {}
      }
    }
  },

  methods: {
    handleKeyDown: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = true
      }
    },

    handleKeyUp: function (event) {
      if (event.key === 'Shift') {
        this.shiftPressed = false
      }
    },

    handleScroll: function (event) {
      this.scrolled = window.scrollY > 100
    },

    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },

    buscarVideos: function () {
      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.videos = []
      this.videoEditar = null
    },

    infiniteHandler: function ($state) {
      VideoAPI.listar(this.pagina, this.filtro).then(data => {
        this.quantidade = data.total

        if (this.pagina <= data.last_page) {
          this.videos.push(
            ...data.data.map(item => {
              return item
            })
          )
          $state.loaded()

          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      })
    },

    changeRouter: function (tab) {
      this.$router.push(`/conteudo/videos/importar/${tab}`)
    },

    modalAssociarVideo: function () {
      if (this.videosSelecionados && this.videosSelecionados.length >= 1) {
        this.videoEdicao = null

        this.videosSelecionados = this.videosSelecionados.sort(function (a, b) {
          return new Date(a.id) - new Date(b.id)
        })

        this.$nextTick(() => {
          this.$refs.modalTopicoVideo.show()
        })
      } else {
        Swal.fire({
          icon: 'warning',
          showCloseButton: true,
          text: 'Selecione uma ou mais vídeos para associar a uma lição'
        })
      }
    },

    modalEditarMassa: function () {
      if (this.videosSelecionados && this.videosSelecionados.length >= 1) {
        this.videoEdicao = null

        this.videosSelecionados = this.videosSelecionados.sort(function (a, b) {
          return new Date(a.id) - new Date(b.id)
        })

        this.$nextTick(() => {
          this.$refs.modalEditarMassa.show()
        })
      } else {
        Swal.fire({
          icon: 'warning',
          showCloseButton: true,
          text: 'Selecione uma ou mais vídeos para poder editar em Massa'
        })
      }
    },

    alteraSelecionada: function (video) {
      if (this.shiftPressed && this.ultimoSelecionado) {
        let maiorQueUltimo = (video.id > this.ultimoSelecionado.id)
        let novosSelecionados = []
        novosSelecionados = this.videos.filter(item => {
          if (maiorQueUltimo) {
            return (item.id <= video.id) && (item.id >= this.ultimoSelecionado.id)
          } else {
            return (item.id <= this.ultimoSelecionado.id) && (item.id >= video.id)
          }
        })
        novosSelecionados.map(video => {
          !this.videosSelecionados.includes(video) && this.videosSelecionados.push(video)
        })
      }
      this.ultimoSelecionado = video
    },

    modalEdicaoVideo: function (video) {
      this.videoEditar = video

      this.$nextTick(() => {
        this.$refs.modalEdicaoVideo.show()
      })
    },

    modalCadastroVideo: function () {
      this.$nextTick(() => {
        this.$refs.modalCadastroVideo.show()
      })
    },
    modalUploadVideo: function () {
      this.$nextTick(() => {
        this.$refs.modalUploadVideo.show()
      })
    },

    deletarVideo: function (video) {
      Swal.fire({
        title: 'Você deseja excluir esse vídeo?',
        text: 'Essa ação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir vídeo!',
        cancelButtonText: 'Cancelar.'
      }).then((result) => {
        if (result.value) {
          const loader = this.$loading.show()
          VideoAPI.deletar(video).then(data => {
            loader.hide()
            Swal.fire({
              icon: 'success',
              showCloseButton: true,
              text: 'Vídeo deletado com sucesso'
            }).then(() => {
              this.buscarVideos()
            })
          }).catch(error => ResponseUtils.handleError(error, loader))
          loader.hide()
        }
      })
    }
  }
}
</script>
